export const SCREENSIZE_BREAKPOINT = 576;

export const PROD_HOST = 'edp';
export const UAT_HOST = 'blueberry';
export const UAT_GTM = 'KMCCW2H';
// export const PROD_GTM = 'PDHNZCV';
export const PROD_GTM = '';

export const TAKAFUL = 'takaful';
export const INSURANCE = 'insurance';
export const EGTB = 'EGTB';
export const EGIB = 'EGIB';
export const HOHH = 'hohh';
export const MALAYSIA = 'malaysia';

export const BUILDING_MIN_SUM_INSURED = 67000;
export const BUILDING_MAX_SUM_INSURED = 5000000;
export const CONTENT_MIN_SUM_INSURED = 18000;
export const CONTENT_MAX_SUM_INSURED = 1000000;
export const LPPSA_MIN_SUM_INSURED = 31_000;
export const LPPSA_MAX_SUM_INSURED = 200_000;

export const MIN_STOREY = 1;
export const MAX_STOREY = 5;

export const MIN_AGE = 18;
export const MAX_AGE = 90;

export const MAX_AMOUNT_LENGTH = 7;

export const BUILDING_CALCULATOR_URL = 'https://bcc.piam.org.my/';

export const AMLA_CODE_PREFIX = ['APPAMLA', 'AML', 'TRN', 'IBMDM'];
export const SCREENING_CODE_PREFIX = 'QTN';

export const SOURCEAPP_ECHANNEL = 1;
export const SOURCEAPP_GOTGAFFILIATE = 6;

export const PF_NUMBER_LENGTH = 8;
